export type ActorTargetKind='npc'|'drop'|'enemy'|'player';
export type ActorTarget={id:string;kind:ActorTargetKind;depth:number;live:boolean;bounds:{x:number;y:number;width:number;height:number}};
const priority:Record<ActorTargetKind,number>={npc:4,drop:3,enemy:2,player:1};
export const targetKey=(target:Pick<ActorTarget,'kind'|'id'>)=>target.kind+':'+target.id;
/** Cycle only live bodies under this exact pointer. Network order never controls priority. */
export function pickActorTarget(targets:readonly ActorTarget[],x:number,y:number,current=''):ActorTarget|undefined{
 const hits=[...new Map(targets.filter(t=>t.live&&x>=t.bounds.x&&y>=t.bounds.y&&x<=t.bounds.x+t.bounds.width&&y<=t.bounds.y+t.bounds.height).map(t=>[targetKey(t),t])).values()].sort((a,b)=>priority[b.kind]-priority[a.kind]||b.depth-a.depth||targetKey(a).localeCompare(targetKey(b)));
 return hits[(hits.findIndex(t=>targetKey(t)===current)+1)%hits.length];
}
/** Explicit enemy identity cannot silently become another enemy after death/despawn. */
export class EnemyTargetLock{
 private chosen:string|null=null;
 private invalid=false;
 select(id:string):void{this.chosen=id;this.invalid=false;}
 clear():void{this.chosen=null;this.invalid=true;}
 resolve<T extends {id:string;hp:number;mapId?:string}>(enemies:readonly T[],mapId:string,fallback:T|null):T|null{
  if(this.invalid)return null;
  if(this.chosen){const enemy=enemies.find(e=>e.id===this.chosen&&e.hp>0&&(e.mapId??'village')===mapId);if(enemy)return enemy;this.clear();return null;}
  return fallback&&fallback.hp>0&&(fallback.mapId??'village')===mapId?fallback:null;
 }
 get blocked():boolean{return this.invalid;}
}
